var map = {
	"./assessment": [
		3578,
		80,
		578
	],
	"./assessment/": [
		3578,
		80,
		578
	],
	"./assessment/index": [
		3578,
		80,
		578
	],
	"./assessment/index.vue": [
		3578,
		80,
		578
	],
	"./driverinfo": [
		5919,
		80,
		919
	],
	"./driverinfo/": [
		5919,
		80,
		919
	],
	"./driverinfo/index": [
		5919,
		80,
		919
	],
	"./driverinfo/index.vue": [
		5919,
		80,
		919
	],
	"./exception/404": [
		7198,
		198
	],
	"./exception/404.vue": [
		7198,
		198
	],
	"./exception/error": [
		8832,
		832
	],
	"./exception/error.vue": [
		8832,
		832
	],
	"./hip": [
		9321,
		80,
		321
	],
	"./hip/": [
		9321,
		80,
		321
	],
	"./hip/index": [
		9321,
		80,
		321
	],
	"./hip/index.vue": [
		9321,
		80,
		321
	],
	"./home": [
		6256,
		256
	],
	"./home/": [
		6256,
		256
	],
	"./home/index": [
		6256,
		256
	],
	"./home/index.vue": [
		6256,
		256
	],
	"./life": [
		2290,
		80,
		290
	],
	"./life/": [
		2290,
		80,
		290
	],
	"./life/index": [
		2290,
		80,
		290
	],
	"./life/index.vue": [
		2290,
		80,
		290
	],
	"./login": [
		968,
		80,
		968
	],
	"./login.vue": [
		968,
		80,
		968
	],
	"./menumgmt": [
		8063,
		63
	],
	"./menumgmt/": [
		8063,
		63
	],
	"./menumgmt/index": [
		8063,
		63
	],
	"./menumgmt/index.vue": [
		8063,
		63
	],
	"./patients": [
		5259,
		80,
		259
	],
	"./patients/": [
		5259,
		80,
		259
	],
	"./patients/index": [
		5259,
		80,
		259
	],
	"./patients/index.vue": [
		5259,
		80,
		259
	],
	"./reg": [
		866,
		80,
		866
	],
	"./reg.vue": [
		866,
		80,
		866
	],
	"./self": [
		178,
		80,
		178
	],
	"./self/": [
		178,
		80,
		178
	],
	"./self/index": [
		178,
		80,
		178
	],
	"./self/index.vue": [
		178,
		80,
		178
	],
	"./setting": [
		8021,
		21
	],
	"./setting/": [
		8021,
		21
	],
	"./setting/index": [
		8021,
		21
	],
	"./setting/index.vue": [
		8021,
		21
	],
	"./systemusability": [
		2389,
		80,
		389
	],
	"./systemusability/": [
		2389,
		80,
		389
	],
	"./systemusability/index": [
		2389,
		80,
		389
	],
	"./systemusability/index.vue": [
		2389,
		80,
		389
	],
	"./vehicleinfo": [
		9882,
		80,
		882
	],
	"./vehicleinfo/": [
		9882,
		80,
		882
	],
	"./vehicleinfo/index": [
		9882,
		80,
		882
	],
	"./vehicleinfo/index.vue": [
		9882,
		80,
		882
	],
	"./video": [
		7102,
		102
	],
	"./video/": [
		7102,
		102
	],
	"./video/index": [
		7102,
		102
	],
	"./video/index.vue": [
		7102,
		102
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6968;
module.exports = webpackAsyncContext;